'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$UserCode$() {
  this.ccQ = null;
  this.ccR = false;
  this.ccO = null;
  this.ccP = false;
}
export { $c_Lpresto_types$UserCode$ as $c_Lpresto_types$UserCode$ };
$p = $c_Lpresto_types$UserCode$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$UserCode$;
/** @constructor */
function $h_Lpresto_types$UserCode$() {
}
export { $h_Lpresto_types$UserCode$ as $h_Lpresto_types$UserCode$ };
$h_Lpresto_types$UserCode$.prototype = $p;
$p.a2t = (function() {
  if ((!this.ccR)) {
    this.ccQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.ccR = true;
  }
  return this.ccQ;
});
$p.sA = (function() {
  if ((!this.ccP)) {
    this.ccO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.ccP = true;
  }
  return this.ccO;
});
var $d_Lpresto_types$UserCode$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$UserCode$, "presto.types$UserCode$", ({
  a2Z: 1,
  D: 1
}));
export { $d_Lpresto_types$UserCode$ as $d_Lpresto_types$UserCode$ };
var $n_Lpresto_types$UserCode$;
function $m_Lpresto_types$UserCode$() {
  if ((!$n_Lpresto_types$UserCode$)) {
    $n_Lpresto_types$UserCode$ = new $c_Lpresto_types$UserCode$();
  }
  return $n_Lpresto_types$UserCode$;
}
export { $m_Lpresto_types$UserCode$ as $m_Lpresto_types$UserCode$ };
//# sourceMappingURL=presto.types$-User-Code$.js.map
